import { apiCall } from '@/services/axios';

export const setActiveWorkspace = (workspaceId) => apiCall('POST', 'users/active-workspace', {
  workspace: workspaceId,
}, {}, {});
